import {
  VIRTUAL_ACCOUNT_INTERNAL_COMMENT_CLP_PATTERN,
  VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_MIN_LENGTH,
  VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_PATTERN,
} from '@/modules/movements/constants/virtualAccountMovement.constant';
import type { VoucherTemplateEntry } from '@/modules/movements/types/download.type';

/**
 * Detecta comentarios con metadata interna de cuentas virtuales.
 * - CLP (CCA): pipe-separated, ej. `0507|355646117298|260612|110943`
 * - COP (ACH): cadena numérica contigua, ej. `999900009220260617000015070000001`
 * No son comentarios de usuario y no deben mostrarse en detalle ni comprobante.
 */
export function isVirtualAccountInternalComment(comment?: string | null): boolean {
  if (!comment?.trim()) return false;

  const trimmed = comment.trim();

  if (VIRTUAL_ACCOUNT_INTERNAL_COMMENT_CLP_PATTERN.test(trimmed)) {
    return true;
  }

  return (
    trimmed.length >= VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_MIN_LENGTH &&
    VIRTUAL_ACCOUNT_INTERNAL_COMMENT_COP_PATTERN.test(trimmed)
  );
}

/**
 * Identifica transacciones de cuenta virtual por metadata interna en el comentario.
 * Solo aplica con la feature flag activa.
 */
export function isVirtualAccountTransaction(
  comment: string | null | undefined,
  isVirtualAccountsEnabled: boolean
): boolean {
  return isVirtualAccountsEnabled && isVirtualAccountInternalComment(comment);
}

/**
 * Determina si el comentario debe ocultarse para una transacción de cuenta virtual.
 */
export function shouldHideVirtualAccountComment(
  comment: string | null | undefined,
  isVirtualAccountsEnabled: boolean
): boolean {
  return isVirtualAccountTransaction(comment, isVirtualAccountsEnabled);
}

/**
 * Resuelve la plantilla del comprobante. Para transacciones de cuenta virtual usa la
 * plantilla default (sin logo regulatorio ni campos específicos de país).
 */
export function resolveVirtualAccountVoucherTemplate(
  templateEntry: VoucherTemplateEntry,
  originCountry: string,
  isVirtualAccountTx: boolean
): string {
  if (isVirtualAccountTx) {
    return templateEntry.default;
  }

  return templateEntry[originCountry as keyof VoucherTemplateEntry] ?? templateEntry.default;
}
